// extracted by mini-css-extract-plugin
export default {"notificationBadge":"_b5ba0e00"};